import { Checklist } from "@common/schemas/checklist";
import { ChecklistScheduleReason } from "../scheduler/scheduler";
import { ChecklistTerminateReason } from "../tour/tourLifecycleManager";
export type ChecklistManagerEvents = {
  checklistStarted: { checklist: Checklist; scheduleReason: ChecklistScheduleReason };
  checklistDismissed: { checklist: Checklist };
  checklistCompleted: { checklist: Checklist };
  checklistTerminated: { checklist: Checklist; reason: ChecklistTerminateReason };
};

export const ChecklistManagerNamespace = "checklistManager" as const;
